module.exports = __webpack_public_path__ + "static/media/blog_grid_8.79c71cd8.jpg";